

// import React, { memo } from 'react'
// import { useHistory } from 'react-router-dom'
// import { FaTrash, FaUserCircle } from 'react-icons/fa'
// import findGif from '../css/loading_old.gif'
// import acceptSound from './accept.mp3'
// import playSound from './play.mp3'

// const BetCard = React.memo(
//   ({
//     allgame,
//     user,
//     deleteChallenge,
//     getPost,
//     challangeReqRun,
//     RejectGame,
//     winnAmount,
//     AcceptChallang,
//     updateChallenge,
//   }) => {
//     const history = useHistory()
//     const [disable, setDisable] = React.useState(challangeReqRun)
//     const [disable_play, setDisable_play] = React.useState(false)

//     const req_chall_fun = (allgameId) => {
//       getPost(allgameId)
//     }

//     const disablebtn = () => {
//       setDisable(true)
//       setTimeout(() => setDisable(false), 3000)
//     }

//     const disable_play_btn = () => {
//       setDisable_play(true)
//       setTimeout(() => setDisable_play(false), 3000)
//     }

//     return (
//       <>
//         <div
//           className="mx-2 mb-3"
//           style={{
//             backgroundColor: '#fff',
//             borderRadius: '15px',
//             border: '1px solid #d1d1d1',
//             overflow: 'hidden',
//             fontFamily: 'sans-serif'
//           }}
//         >
//           {/* Header Section */}
//           <div 
//             className="px-3 py-2 d-flex justify-content-between align-items-center" 
//             style={{ borderBottom: '1px solid #d1d1d1' }}
//           >
//             <span style={{ color: '#8833ff', fontWeight: 'bold', fontSize: '16px' }}>
//               Challange From {allgame?.Created_by?.Name}
//             </span>
            
//             {user === allgame?.Created_by?._id && allgame?.Status === 'new' && (
//               <FaTrash 
//                 size={14} 
//                 style={{ color: '#dc3545', cursor: 'pointer' }} 
//                 onClick={() => deleteChallenge(allgame?._id)} 
//               />
//             )}
//           </div>

//           {/* Body Section */}
//           <div 
//             className="px-3 py-3 d-flex align-items-center justify-content-between" 
//             style={{ backgroundColor: '#f8f8f8' }}
//           >
//             {/* Entry Fee */}
//             <div className="text-center">
//               <div style={{ fontSize: '13px', fontWeight: '500', marginBottom: '5px' }}>Entry Fee</div>
//               <div className="d-flex align-items-center justify-content-center">
//                 <img src="/images/LandingPage_img/global-rupeeIcon.png" alt="icon" width="22px" />
//                 <span style={{ fontSize: '18px', fontWeight: 'bold', marginLeft: '5px' }}>{allgame?.Game_Ammount}</span>
//               </div>
//             </div>

//             {/* Center Action Button */}
//             <div className="text-center">
//               {/* PLAY BUTTON (Same as Screenshot) */}
//               {user !== allgame?.Created_by?._id && allgame?.Status === 'new' && (
//                 <button
//                   disabled={disable_play}
//                   onClick={() => {
//                     disable_play_btn()
//                     AcceptChallang(allgame._id)
//                   }}
//                   style={{
//                     background: '#7c3aed',
//                     color: '#fff',
//                     border: 'none',
//                     padding: '8px 25px',
//                     borderRadius: '8px',
//                     fontWeight: 'bold',
//                     fontSize: '15px'
//                   }}
//                 >
//                   Play
//                 </button>
//               )}

//               {/* Finding UI */}
//               {user === allgame?.Created_by?._id && allgame?.Status === 'new' && (
//                 <div className="d-flex flex-column align-items-center">
//                   <img src={findGif} style={{ width: '20px' }} alt="loading" />
//                   <span style={{ fontSize: '10px', color: '#666', marginTop: '2px' }}>FINDING...</span>
//                 </div>
//               )}

//               {/* Start/Reject UI */}
//               {user === allgame?.Created_by?._id && allgame?.Status === 'requested' && (
//                 <div className="d-flex gap-1">
//                   <audio src={acceptSound} autoPlay></audio>
//                   <button className="btn btn-success btn-sm" onClick={() => { disablebtn(); req_chall_fun(allgame._id); }}>
//                     {disable ? 'WAIT...' : 'START'}
//                   </button>
//                   <button className="btn btn-danger btn-sm" onClick={() => RejectGame(allgame._id)}>REJECT</button>
//                 </div>
//               )}

//               {/* Running/Start Game UI */}
//               {user !== allgame?.Created_by?._id && allgame?.Status === 'running' && (
//                 <>
//                   <audio src={playSound} autoPlay></audio>
//                   <button 
//                     className="btn btn-success btn-sm" 
//                     onClick={() => { disablebtn(); updateChallenge(allgame._id); history.push(`/viewgame1/${allgame._id}`); }}
//                   >
//                     START GAME
//                   </button>
//                 </>
//               )}
//             </div>

//             {/* Winning Prize */}
//             <div className="text-center">
//               <div style={{ fontSize: '13px', fontWeight: '500', marginBottom: '5px' }}>Winning Prize</div>
//               <div className="d-flex align-items-center justify-content-center">
//                 <img src="/images/LandingPage_img/global-rupeeIcon.png" alt="icon" width="22px" />
//                 <span style={{ fontSize: '18px', fontWeight: 'bold', marginLeft: '5px' }}>
//                   {allgame?.Game_Ammount + winnAmount(allgame?.Game_Ammount)}
//                 </span>
//               </div>
//             </div>
//           </div>

//           {/* Requested User Footer */}
//           {allgame?.Status === 'requested' && (
//             <div className="px-3 py-1 d-flex align-items-center" style={{ backgroundColor: '#eeeeee', borderTop: '1px solid #d1d1d1' }}>
//               <span style={{ fontSize: '11px', marginRight: '5px' }}>Requested by:</span>
//               <span style={{ fontSize: '11px', fontWeight: 'bold' }}>{allgame?.Accepetd_By?.Name}</span>
//             </div>
//           )}
//         </div>
//       </>
//     )
//   }
// )

// export default memo(BetCard)

// import React, { memo } from 'react'
// import { useHistory } from 'react-router-dom'
// import { FaTrash, FaUserCircle } from 'react-icons/fa'
// import findGif from '../css/loading_old.gif'
// import acceptSound from './accept.mp3'
// import playSound from './play.mp3'

// const BetCard = React.memo(
//   ({
//     allgame,
//     user,
//     deleteChallenge,
//     getPost,
//     challangeReqRun,
//     RejectGame,
//     winnAmount,
//     AcceptChallang,
//     updateChallenge,
//   }) => {
//     const history = useHistory()
//     const [disable, setDisable] = React.useState(challangeReqRun)
//     const [disable_play, setDisable_play] = React.useState(false)

//     const req_chall_fun = (allgameId) => {
//       getPost(allgameId)
//     }

//     const disablebtn = () => {
//       setDisable(true)
//       setTimeout(() => setDisable(false), 3000)
//     }

//     const disable_play_btn = () => {
//       setDisable_play(true)
//       setTimeout(() => setDisable_play(false), 3000)
//     }

//     return (
//       <>
//         <div
//           className="mx-2 mb-2" // Reduced bottom margin
//           style={{
//             backgroundColor: '#fff',
//             borderRadius: '12px', // Slightly smaller radius for minimal look
//             border: '1px solid #d1d1d1',
//             overflow: 'hidden',
//             fontFamily: 'sans-serif',
//           }}
//         >
//           {/* Header Section - Reduced py-1 */}
//           <div 
//             className="px-3 py-1 d-flex justify-content-between align-items-center" 
//             style={{ borderBottom: '1px solid #e0e0e0' }}
//           >
//             <span style={{ color: '#8833ff', fontWeight: '600', fontSize: '14px' }}>
//               Challange From {allgame?.Created_by?.Name}
//             </span>
            
//             {user === allgame?.Created_by?._id && allgame?.Status === 'new' && (
//               <FaTrash 
//                 size={12} 
//                 style={{ color: '#dc3545', cursor: 'pointer' }} 
//                 onClick={() => deleteChallenge(allgame?._id)} 
//               />
//             )}
//           </div>

//           {/* Body Section - Reduced py-2 */}
//           <div 
//             className="px-3 py-2 d-flex align-items-center justify-content-between" 
//             style={{ backgroundColor: '#f9f9f9' }}
//           >
//             {/* Entry Fee - Stacked tightly */}
//             <div className="text-left">
//               <div style={{ fontSize: '11px', color: '#333', marginBottom: '2px' }}>Entry Fee</div>
//               <div className="d-flex align-items-center">
//                 <img src="/images/LandingPage_img/global-rupeeIcon.png" alt="icon" width="18px" />
//                 <span style={{ fontSize: '16px', fontWeight: 'bold', marginLeft: '4px' }}>{allgame?.Game_Ammount}</span>
//               </div>
//             </div>

//             {/* Center Action Button - Compact padding */}
//             <div className="text-center">
//               {user !== allgame?.Created_by?._id && allgame?.Status === 'new' && (
//                 <button
//                   disabled={disable_play}
//                   onClick={() => {
//                     disable_play_btn()
//                     AcceptChallang(allgame._id)
//                   }}
//                   style={{
//                     background: '#7c3aed',
//                     color: '#fff',
//                     border: 'none',
//                     padding: '5px 22px', // Tighter padding
//                     borderRadius: '6px',
//                     fontWeight: 'bold',
//                     fontSize: '14px',
//                     cursor: 'pointer'
//                   }}
//                 >
//                   Play
//                 </button>
//               )}

//               {user === allgame?.Created_by?._id && allgame?.Status === 'new' && (
//                 <div className="d-flex flex-column align-items-center" style={{ lineHeight: '1' }}>
//                   <img src={findGif} style={{ width: '16px' }} alt="loading" />
//                   <span style={{ fontSize: '9px', color: '#666', marginTop: '1px' }}>FINDING...</span>
//                 </div>
//               )}

//               {user === allgame?.Created_by?._id && allgame?.Status === 'requested' && (
//                 <div className="d-flex align-items-center" style={{ gap: '5px' }}>
//                   <audio src={acceptSound} autoPlay></audio>
//                   <button 
//                     className="btn btn-success btn-sm" 
//                     style={{ fontSize: '10px', padding: '2px 8px' }}
//                     onClick={() => { disablebtn(); req_chall_fun(allgame._id); }}
//                   >
//                     {disable ? 'WAIT...' : 'START'}
//                   </button>
//                   <button 
//                     className="btn btn-danger btn-sm" 
//                     style={{ fontSize: '10px', padding: '2px 8px' }}
//                     onClick={() => RejectGame(allgame._id)}
//                   >
//                     REJECT
//                   </button>
//                 </div>
//               )}

//               {user !== allgame?.Created_by?._id && allgame?.Status === 'running' && (
//                 <>
//                   <audio src={playSound} autoPlay></audio>
//                   <button 
//                     className="btn btn-success btn-sm" 
//                     style={{ fontSize: '11px', padding: '3px 10px' }}
//                     onClick={() => { disablebtn(); updateChallenge(allgame._id); history.push(`/viewgame1/${allgame._id}`); }}
//                   >
//                     START GAME
//                   </button>
//                 </>
//               )}
//             </div>

//             {/* Winning Prize - Stacked tightly */}
//             <div className="text-right">
//               <div style={{ fontSize: '11px', color: '#333', marginBottom: '2px' }}>Winning Prize</div>
//               <div className="d-flex align-items-center justify-content-end">
//                 <img src="/images/LandingPage_img/global-rupeeIcon.png" alt="icon" width="18px" />
//                 <span style={{ fontSize: '16px', fontWeight: 'bold', marginLeft: '4px' }}>
//                   {allgame?.Game_Ammount + winnAmount(allgame?.Game_Ammount)}
//                 </span>
//               </div>
//             </div>
//           </div>

//           {/* Requested User Footer - Minimal Height */}
//           {allgame?.Status === 'requested' && (
//             <div className="px-3 d-flex align-items-center" style={{ backgroundColor: '#eeeeee', borderTop: '1px solid #d1d1d1', height: '20px' }}>
//               <span style={{ fontSize: '10px', marginRight: '5px', color: '#666' }}>Accepted by:</span>
//               <span style={{ fontSize: '10px', fontWeight: 'bold' }}>{allgame?.Accepetd_By?.Name}</span>
//             </div>
//           )}
//         </div>
//       </>
//     )
//   }
// )

// export default memo(BetCard)


import React, { memo } from 'react'
import { useHistory } from 'react-router-dom'
import { FaTrash, FaUserCircle } from 'react-icons/fa'
import findGif from '../css/loading_old.gif'
import acceptSound from './accept.mp3'
import playSound from './play.mp3'

const BetCard = React.memo(
  ({
    allgame,
    user,
    deleteChallenge,
    getPost,
    challangeReqRun,
    RejectGame,
    winnAmount,
    AcceptChallang,
    updateChallenge,
  }) => {
    const history = useHistory()
    const [disable, setDisable] = React.useState(challangeReqRun)
    const [disable_play, setDisable_play] = React.useState(false)

    const req_chall_fun = (allgameId) => {
      getPost(allgameId)
    }

    const disablebtn = () => {
      setDisable(true)
      setTimeout(() => setDisable(false), 3000)
    }

    const disable_play_btn = () => {
      setDisable_play(true)
      setTimeout(() => setDisable_play(false), 3000)
    }

    return (
      <>
        <div
          className="mx-2 mb-2"
          style={{
            backgroundColor: '#fff',
            borderRadius: '12px',
            border: '1px solid #d1d1d1',
            overflow: 'hidden',
            fontFamily: 'sans-serif'
          }}
        >
          {/* Header Section */}
          <div 
            className="px-3 py-1 d-flex justify-content-between align-items-center" 
            style={{ borderBottom: '1px solid #e0e0e0' }}
          >
            <span style={{ color: '#ec9728', fontWeight: '600', fontSize: '14px' }}>
              Challange From {allgame?.Created_by?.Name}
            </span>
            
            {user === allgame?.Created_by?._id && allgame?.Status === 'new' && (
              <FaTrash 
                size={12} 
                style={{ color: '#dc3545', cursor: 'pointer' }} 
                onClick={() => deleteChallenge(allgame?._id)} 
              />
            )}
          </div>

          {/* Body Section */}
          <div 
            className="px-3 py-2 d-flex align-items-center justify-content-between" 
            style={{ backgroundColor: '#f9f9f9' }}
          >
            {/* Entry Fee */}
            <div className="text-left">
              <div style={{ fontSize: '11px', color: '#333', marginBottom: '2px' }}>Entry Fee</div>
              <div className="d-flex align-items-center">
                <img src="/images/LandingPage_img/global-rupeeIcon.png" alt="icon" width="18px" />
                <span style={{ fontSize: '16px', fontWeight: 'bold', marginLeft: '4px', color:"#000" }}>{allgame?.Game_Ammount}</span>
              </div>
            </div>

            {/* Center Action Button Section */}
            <div className="text-center">
              {/* 1. PLAY BUTTON (User is not creator, status is new) */}
              {user !== allgame?.Created_by?._id && allgame?.Status === 'new' && (
                <button
                  disabled={disable_play}
                  onClick={() => {
                    disable_play_btn()
                    AcceptChallang(allgame._id)
                  }}
                  style={{
                    background: '#7c3aed',
                    color: '#fff',
                    border: 'none',
                    padding: '5px 22px',
                    borderRadius: '6px',
                    fontWeight: 'bold',
                    fontSize: '14px',
                    cursor: 'pointer'
                  }}
                >
                  Play
                </button>
              )}

              {/* 2. FINDING UI (User is creator, status is new) */}
              {user === allgame?.Created_by?._id && allgame?.Status === 'new' && (
                <div className="d-flex flex-column align-items-center" style={{ lineHeight: '1' }}>
                  <img src={findGif} style={{ width: '16px' }} alt="loading" />
                  <span style={{ fontSize: '9px', color: '#666', marginTop: '2px' }}>FINDING...</span>
                </div>
              )}

              {/* 3. START/REJECT UI (User is creator, status is requested) */}
              {user === allgame?.Created_by?._id && allgame?.Status === 'requested' && (
                <div className="d-flex align-items-center" style={{ gap: '5px' }}>
                  <audio src={acceptSound} autoPlay></audio>
                  <button 
                    className="btn btn-success btn-sm" 
                    style={{ fontSize: '10px', padding: '2px 8px', fontWeight: 'bold' }}
                    onClick={() => { disablebtn(); req_chall_fun(allgame._id); }}
                  >
                    {disable ? 'WAIT...' : 'START'}
                  </button>
                  <button 
                    className="btn btn-danger btn-sm" 
                    style={{ fontSize: '10px', padding: '2px 8px', fontWeight: 'bold' }}
                    onClick={() => RejectGame(allgame._id)}
                  >
                    REJECT
                  </button>
                </div>
              )}

              {/* 4. REQUESTED/CANCEL UI (User is player who requested to play) */}
              {user !== allgame?.Created_by?._id && allgame?.Status === 'requested' && (
                <div className="d-flex flex-column align-items-center" style={{ gap: '2px' }}>
                  <span style={{ fontSize: '9px', color: '#ffc107', fontWeight: 'bold', textTransform: 'uppercase' }}>Requested</span>
                  <button 
                    className="btn btn-danger btn-sm" 
                    style={{ fontSize: '10px', padding: '1px 10px', borderRadius: '4px' }}
                    onClick={() => RejectGame(allgame?._id)}
                  >
                    CANCEL
                  </button>
                </div>
              )}

              {/* 5. START GAME BUTTON (User is player, creator accepted, status is running) */}
              {user !== allgame?.Created_by?._id && allgame?.Status === 'running' && (
                <>
                  <audio src={playSound} autoPlay></audio>
                  <button 
                    className="btn btn-success btn-sm" 
                    style={{ fontSize: '11px', padding: '4px 12px', fontWeight: 'bold', borderRadius: '6px' }}
                    onClick={() => { disablebtn(); updateChallenge(allgame._id); history.push(`/viewgame1/${allgame._id}`); }}
                  >
                    START GAME
                  </button>
                </>
              )}
            </div>

            {/* Winning Prize */}
            <div className="text-right">
              <div style={{ fontSize: '11px', color: '#333', marginBottom: '2px' }}>Winning Prize</div>
              <div className="d-flex align-items-center justify-content-end">
                <img src="/images/LandingPage_img/global-rupeeIcon.png" alt="icon" width="18px" />
                <span style={{ fontSize: '16px', fontWeight: 'bold', marginLeft: '4px', color:"#000" }}>
                  {allgame?.Game_Ammount + winnAmount(allgame?.Game_Ammount)}
                </span>
              </div>
            </div>
          </div>

          {/* Footer for Creator to see who requested */}
          {user === allgame?.Created_by?._id && allgame?.Status === 'requested' && (
            <div className="px-3 d-flex align-items-center" style={{ backgroundColor: '#eeeeee', borderTop: '1px solid #d1d1d1', height: '22px' }}>
              <span style={{ fontSize: '10px', marginRight: '5px', color: '#666' }}>Requested by:</span>
              <span style={{ fontSize: '10px', fontWeight: 'bold', color: '#333' }}>{allgame?.Accepetd_By?.Name}</span>
            </div>
          )}
        </div>
      </>
    )
  }
)

export default memo(BetCard)